<template>
  <div class="booking-manifest-goods-info" style="display:flex;flex-direction:column">
    <div class=" operations">
      <div class="triggers">
        <div>
          <el-button :disabled="isRongeTong ? !innerIsEditing : canEdit" type="primary" @click="showEditDialog(true)">{{ $t('Payment.new') }}</el-button>
          <el-button v-if="isSeaHouseChannel || isWseChannel || isRongeTong" :disabled="isRongeTong ? !innerIsEditing : canEdit" type="primary" @click="copy">{{ $t('CargoMsg.Cargo_Copy') }}</el-button>
          <!-- <el-button :disabled="!innerIsEditing" type="primary" @click="showEditDialog(false)">编辑</el-button> -->
          <el-button :disabled="isRongeTong ? isDeleteDisabled : canEdit" type="danger" @click="remove">{{ $t('FileHistory.Delete') }}</el-button>
          <el-button
            v-show="!lclView"
            :disabled="canEdit"
            type="primary"
            @click="importFromContainer"
          >{{ $t('SeaExport.GetPackingInformation') }}</el-button>
          <el-button
            v-show="job.uuid&&job.lclMasterUuid"
            :disabled="innerIsEditing"
            type="primary"
            @click="importFromLcLContainer"
          >{{ $t('SeaExport.SynchronizeMainTicketPackingInformation') }}</el-button>
          <!--主票导入货物明细 这个查过代码没用了 lclView = false 不显示的-->
          <el-upload
            v-show="lclView"
            :disabled="!innerIsEditing"
            :action="URL.seaExport.manifestImportExcelLcl"
            :headers="{sessionId: $store.getters.userInfo.sessionId}"
            :show-file-list="false"
            :data="{ jobUuid: job.uuid }"
            accept=".xls, .xlsx"
            :before-upload="beforeUpload"
            :on-success="uploadSuccess"
            style="display: inline-block;padding-left: 5px;"
          >
            <el-button v-show="lclView" slot="trigger" :disabled="!innerIsEditing" type="primary">{{ $t('SeaExport.ExcelImport') }}</el-button>
          </el-upload>
          <el-button
            v-show="manifestInfo.uuid"
            no="cfmConfirm"
            :disabled="isEdit"
            type="primary"
            @click="cfmBtnClickHandlers"
          >{{ $t('SeaExport.Confirm') }}
          </el-button>
          <el-button
            v-show="manifestInfo.uuid && manifestInfo.syncState !== 1"
            no="SynchronizePackingInfo"
            :disabled="isEdit"
            type="primary"
            @click="synchronizePackingInfo"
          >{{ $t('SeaExport.SynchronizePackingInfo') }}</el-button>
        </div>
      </div>
      <div class="calculation" style="float: right">
        <span style="margin-left: 20px">{{ $t('SeaExport.TotalNumberOfPackages') }}：{{ quantity }}</span>
        <span style="margin-left: 20px">{{ $t('SeaExport.TotalWeight') }}：{{ weight }}</span>
        <span style="margin-left: 20px">{{ $t('SeaExport.TotalCubage') }}：{{ cubage }}</span>
      </div>
    </div>
    <cargo-ag-grid
      config-module="130199"
      :grid-options="gridOptions"
      :column-defs="columnDefs"
      :row-data="finalRowData"
      style="width:100%;height:200px;margin-top:5px"
      @gridReady="onGridReady"
    />
    <!-- 编辑弹窗 -->
    <el-dialog
      v-el-drag-dialog
      :visible.sync="editDialog.visible"
      :title="editDialog.title"
      width="400px"
      :close-on-click-modal="false"
    >
      <div class="app-main-inner-row" style="padding-bottom: 10px;">
        <el-form label-width="110px" label-position="left">
          <el-form-item v-if="!isAddSpelling" :label="$t('SeaExport.SoNo')">
            <el-input v-model="editDialog.form.soNo" :disabled="!isEditing" />
          </el-form-item>
          <el-form-item :label="$t('Payment.containerNo')">
            <el-input v-model="editDialog.form.containerNo" :disabled="!isEditing" @change="editDialog.form.containerNo=toUpperCaseTrim(editDialog.form.containerNo)" />
          </el-form-item>
          <el-form-item :label="$t('SeaExport.Soc')">
            <el-input v-model="editDialog.form.sealNo" :disabled="!isEditing" @change="editDialog.form.sealNo=toUpperCaseTrim(editDialog.form.sealNo)" />
          </el-form-item>
          <el-form-item :label="$t('SeaExport.ContainerSize')">
            <el-input v-model="editDialog.form.eqSize" :disabled="!isEditing" />
          </el-form-item>
          <el-form-item :label="$t('queryJob.englishDescriptionOfGoods')">
            <el-input :disabled="true" :value="editDialog.form.cargoEnglishName">
              <i
                slot="suffix"
                :class="isEditing?'el-input__icon el-icon-edit':'el-input__icon el-icon-search'"
                style="font-size: 12px;cursor: pointer;color: black;"
                @click="showAdvanceTextDialog($t('queryJob.englishDescriptionOfGoods'),editDialog.form.cargoEnglishName, changeCargoEnglishName)"
              />
            </el-input>
          </el-form-item>
          <el-form-item :label="$t('SeaExport.Marks')">
            <el-input :disabled="true" :value="editDialog.form.mark">
              <i
                slot="suffix"
                :class="isEditing?'el-input__icon el-icon-edit':'el-input__icon el-icon-search'"
                style="font-size: 12px;cursor: pointer;color: black;"
                @click="showAdvanceTextDialog($t('SeaExport.Marks'),editDialog.form.mark, changeMark)"
              />
            </el-input>
          </el-form-item>
          <el-form-item label="HSCode">
            <el-input :disabled="true" :value="editDialog.form.hsCode">
              <i
                slot="suffix"
                :class="isEditing?'el-input__icon el-icon-edit':'el-input__icon el-icon-search'"
                style="font-size: 12px;cursor: pointer;color: black;"
                @click="showAdvanceTextDialog('HSCode',editDialog.form.hsCode,val=>{editDialog.form.hsCode=val})"
              />
            </el-input>
          </el-form-item>
          <el-form-item :label="$t('SeaExport.Package')">
            <el-input v-model="editDialog.form.packing" :disabled="!isEditing" />
          </el-form-item>
          <el-form-item :label="$t('SeaExport.Quantity')">
            <el-input-number
              v-model="editDialog.form.quantity"
              :min="0"
              :disabled="!isEditing"
              :controls="false"
              style="width:100%"
            />
          </el-form-item>
          <el-form-item v-if="isSeaHouseChannel" :label="$t('SeaExport.Weight')">
            <el-input-number
              v-model="editDialog.form.weight"
              :min="0"
              :disabled="!isEditing"
              :controls="false"
              :precision="3"
              style="width:100%"
              @blur="editDialog.form.weight=roundHalfUp(editDialog.form.weight,3)"
            />
          </el-form-item>
          <el-form-item v-else :label="$t('SeaExport.Weight')">
            <el-input-number
              v-model="editDialog.form.weight"
              :min="0"
              :disabled="!isEditing"
              :controls="false"
              :precision="3"
              style="width:70%"
              @blur="editDialog.form.weight=roundHalfUp(editDialog.form.weight,3)"
            />
            <el-select v-model="editDialog.form.weightUnit" style="width:30%">
              <el-option
                v-for="item in WEIGHT_UNIT"
                :key="item.code"
                :label="item.code"
                :value="item.code"
              />
            </el-select>
          </el-form-item>
          <el-form-item v-if="isSeaHouseChannel" :label="$t('SeaExport.Cubage')">
            <el-input-number
              v-model="editDialog.form.cubage"
              :min="0"
              :disabled="!isEditing"
              :controls="false"
              :precision="3"
              style="width:100%"
              @blur="editDialog.form.cubage=roundHalfUp(editDialog.form.cubage,3)"
            />
          </el-form-item>
          <el-form-item v-else :label="$t('SeaExport.Cubage')">
            <el-input-number
              v-model="editDialog.form.cubage"
              :min="0"
              :disabled="!isEditing"
              :controls="false"
              :precision="3"
              style="width:70%"
              @blur="editDialog.form.cubage=roundHalfUp(editDialog.form.cubage,3)"
            />
            <el-select v-model="editDialog.form.cubageUnit" style="width:30%">
              <el-option
                v-for="item in CUBAGE_UNIT"
                :key="item.code"
                :label="item.code"
                :value="item.code"
              />
            </el-select>
          </el-form-item>
          <el-form-item label="UN Code">
            <el-input v-model="editDialog.form.danUNNo" :disabled="!isEditing" />
          </el-form-item>
          <el-form-item :label="$t('SeaExport.DangerousClass')">
            <el-input v-model="editDialog.form.danClassNo" :disabled="!isEditing" />
          </el-form-item>
          <el-form-item :label="$t('SeaExport.DangerousGoodsContact')">
            <el-input v-model="editDialog.form.dngrContactUser" :disabled="!isEditing" />
          </el-form-item>
          <el-form-item :label="$t('SeaExport.DangerousGoodsContactPhoneNumber')">
            <el-input v-model="editDialog.form.dngrContactNumber" :disabled="!isEditing" />
          </el-form-item>
          <el-form-item :label="$t('SeaExport.ediStatus')">
            <el-input :disabled="true" :value="editDialog.title === $t('common.btn.new') ? $t('SeaExport.notSend') : ColumnUtils.ediStateFunction(editDialog.form.ediStatus)" />
          </el-form-item>
        </el-form>
      </div>
      <span slot="footer">
        <el-button v-show="innerIsEditing" type="primary" @click="save">{{ $t('common.btn.save') }}</el-button>
        <el-button @click="editDialog.visible=false">{{ innerIsEditing?$t('common.btn.cancel'):$t('common.btn.close') }}</el-button>
      </span>
    </el-dialog>
    <!-- 高级文本弹框 -->
    <el-dialog
      v-el-drag-dialog
      :visible.sync="advanceTextDialog.visible"
      :title="advanceTextDialog.title"
      width="600px"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
    >
      <el-input v-model="advanceTextDialog.value" :disabled="!isEditing" type="textarea" rows="10" />
      <span slot="footer">
        <el-button v-show="isEditing" type="primary" @click="finishAdvanceText">{{ $t('common.btn.confirm') }}</el-button>
        <el-button
          @click="advanceTextDialog.visible=false"
        >{{ $t('common.btn.close') }}</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import CargoAgGridCommonInputEditor from '@/components/Cargo/Common/CargoAgGridCommonInputEditor'
import CargoAgGridCommonTextareaEditor from '@/components/Cargo/Common/CargoAgGridCommonTextareaEditor'
import { TabError } from '@/utils/class/TabError'
import { roundHalfUp } from '@/utils/NumberUtils'
import ContainerNoHelper from '@/utils/containerNoHelper'
import ColumnUtils from '@/utils/ColumnUtils'
import { AutoIncrementNum } from '@/utils/commonUtil'
import { SeaExportJob } from '@/class/model/booking/SeaExportJob'
import { ManifestInfo } from '@/class/model/booking/ManifestInfo'
import { ManifestGoodsInfo } from '@/class/model/booking/ManifestGoodsInfo'
import URL from '@/api/urlTranslator'
import StrUtils from '@/utils/StrUtils'
import { getHeaderComponentParamsWithWarning } from '@/utils/agGrid'
import { SEUtils } from '@/class/cargo/model/utils/SEUtils'
import { PrePlanBookingUtil } from '@/class/cargo/model/utils/PrePlanBookingUtil'
import { isNumber } from '@/utils/validate'
import { WEIGHT_UNIT, CUBAGE_UNIT } from '@/class/cargo/model/parameters/SeaExportConstants'
import CargoAgGridSelectEditor from '@/components/Cargo/Common/CargoAgGridSelectEditor/index'
import { ThirdPartyMappingUtil } from '@/class/cargo/model/utils/ThirdPartyMappingUtil'
import CargoAgGridAdvanceSelectEditor from '@/components/Cargo/Common/CargoAgGridAdvanceSelectEditor'
import { deepClone } from '@/utils'
import { cache, cacheName } from '@/utils/cacheManager'
import {
  DANGEROUS_GOODS_SEA_HOUSE,
  DANGEROUS_GOODS_WSE, FROZEN_GOODS_SEA_HOUSE, FROZEN_GOODS_WSE,
  PACKING_GOODS,
  WSE_MANIFEST
} from '@/class/cargo/model/parameters/SystemConstants'
import { ManifestCfmState } from '@/class/cargo/model/parameters/ManifestCfmState'
import { confirmManifest, synchronousManifest } from '@/api/seaExport/manifestInfo'
import { getLoading } from '@/utils/utilBaseElement'
import * as commonUtil from '@/utils/commonUtil'
import * as CommonState from '@/class/cargo/model/parameters/CommonState'
import * as EdiState from '@/class/cargo/model/parameters/EdiState'
import { getMappingList } from '@/api/sysManage/baseConfig/mappingManage'

export default {
  name: 'BookingManifestGoodsInfo',
  props: {
    job: { type: Object, required: true },
    manifestInfo: { type: Object, required: true },
    isEditing: { type: Boolean, required: true },
    isEdit: { type: Boolean, required: true },
    lclView: { type: Boolean, default: false },
    isOrNotDisplaySoNo: { type: Boolean, default: false },
    isAddSpelling: { type: Boolean, default: false },
    isSeaHouseChannel: { type: Boolean, default: false },
    isWseChannel: { type: Boolean, default: false },
    isRongeTong: { type: Boolean, default: false },
    showCombinedManifest: { type: Boolean, default: false },
    specialCharacterCheck: { type: Boolean, default: false },
    vgmRequiredInput: { type: Boolean, default: false },
    channel: { type: Number, default: 0 },
    isUppercaseByConfig: { type: Boolean, default: true }
  },
  data() {
    return {
      ManifestCfmState,
      sendType: EdiState.SEND_TYPES,
      URL,
      roundHalfUp,
      ColumnUtils,
      thirdPartyMappingUtil: null,
      seaHouseCache: {
        boxList: [],
        packages: [],
        ooclBoxList: [],
        ooclPackages: [],
        tempUnitList: [{ code: 'C', name: '摄氏度' }, { code: 'F', name: '华氏度' }]
      },
      wseCache: {
        boxList: [],
        packages: [],
        tempUnitList: [{ code: 'C摄氏度', name: '摄氏度' }, { code: 'F华氏度', name: '华氏度' }]
      },
      rongeTong: {
        boxList: [],
        packages: [],
        tempUnitList: [{ code: '摄氏度℃', name: '摄氏度℃' }, { code: '华氏度℉', name: '华氏度℉' }],
        vgmWeightingMethodList: [{ code: 'SM1' }, { code: 'SM2' }]
      },
      columnDefsGC: [],
      dangerousInputMode: false, // 危险品输入模式
      gridOptions: {
        rowSelection: 'multiple',
        singleClickEdit: true,
        suppressCellSelection: true,
        // 选中 勾选框或者其他列 都会触发
        onCellFocused: (event) => {
          this.onGridCellFocused(event)
        },
        // 选中 勾选框触发
        onRowSelected: (event) => {
          this.onGridRowSelected(event)
        },
        onRowClicked: this.onRowClicked,
        frameworkComponents: {
          CargoAgGridCommonInputEditor,
          CargoAgGridCommonTextareaEditor,
          CargoAgGridSelectEditor,
          CargoAgGridAdvanceSelectEditor
        },
        context: {
          componentParent: this
        }
      },
      rowData: [],
      gridApi: null,
      selectedRow: null,
      selectedRows: [], // 存储所有选中的行
      cargoEnglishNameCheck: null,
      markCheck: null,
      autoIncrementNum: new AutoIncrementNum(),
      containerNoClass: '',
      editDialog: {
        visible: false,
        title: '',
        form: new ManifestGoodsInfo().fillDefaultValue().getData()
      },
      advanceTextDialog: {
        visible: false,
        title: '',
        value: '',
        successCallback: null
      },
      WEIGHT_UNIT,
      CUBAGE_UNIT,
      quantity: 0,
      weight: 0.00,
      cubage: 0.00,
      soNoList: [],
      isDangerousGoods: false
    }
  },
  computed: {
    vgmWeightingMethodList() {
      return this.rongeTong.vgmWeightingMethodList
    },
    innerIsEditing() {
      return this.isEditing && Boolean(this.manifestInfo.uuid)
    },
    canEdit() {
      const isSent = PrePlanBookingUtil.isSent(this.manifestInfo)
      return ((!this.innerIsEditing || Boolean((this.isSeaHouseChannel || this.isWseChannel || this.isRongeTong) && isSent)) && this.manifestInfo.todo !== 'new')
    },
    // 删除按钮是否禁用
    isDeleteDisabled() {
      if (!this.innerIsEditing) {
        return true
      }
      // 如果没有勾选任何数据，禁用删除按钮
      if (!this.selectedRows || this.selectedRows.length === 0) {
        return true
      }
      // 允许删除的状态
      const allowedStates = ['-1', '22', '23', '61']
      // 检查所有勾选的数据，只要有一条不在允许的状态中，就禁用删除按钮
      for (const row of this.selectedRows) {
        const state = String(row.seaHouseState || '-1')
        if (!allowedStates.includes(state)) {
          return true
        }
      }
      return false
    },
    isZh() {
      return this.$store.getters.language === 'zh'
    },
    isShangHai() {
      return this.manifestInfo.portOfLoading === 'CNSHA'
    },
    isQingDao() {
      return this.manifestInfo.portOfLoading === 'CNTAO'
    },
    columnDefs() {
      let columnDefs
      let columnDefsGC
      let columnDefsGCTF
      let columnDefsGCForSeaHouse
      if (this.isSeaHouseChannel || this.isWseChannel || this.isRongeTong) {
        columnDefs = [
          {
            headerName: '',
            field: '',
            width: 65,
            headerCheckboxSelection: true,
            checkboxSelection: true,
            sortable: false,
            suppressMenu: true,
            suppressSizeToFit: true,
            resizable: false
          },
          {
            headerName: this.$t('SeaExport.SoNo'),
            colId: 'soNo',
            field: 'soNo',
            width: 100,
            hide: this.isAddSpelling,
            editable: (params) => this.isEditing && this.isSent(params),
            headerClass: 'required-label',
            cellEditor: 'CargoAgGridSelectEditor',
            cellEditorParams: {
              tagName: 'name',
              tagValue: 'code',
              options: this.soNoList,
              selectProps: {
                style: 'width: 100%',
                allowCreate: true,
                filterable: true,
                clearable: true
              },
              inputProps: {
                maxlength: 30
              }
            },
            onCellValueChanged: p => this.onCellChange2(p)
          }, {
            headerName: this.$t('Payment.containerNo'),
            colId: 'containerNo',
            field: 'containerNo',
            width: 100,
            headerClass: 'required-label',
            cellStyle: params => {
              return this.containerNbrStyleFunction(params.data)
            },
            editable: (params) => this.isEditing && this.isSent(params),
            cellEditor: 'CargoAgGridCommonInputEditor',
            cellRenderer: (params) => {
              return this.formatConversion(params.value)
            },
            cellEditorParams: {
              isUppercase: true,
              isTrim: true,
              inputProps: {
                maxlength: 11
              }
            }
          }, {
            headerName: this.$t('SeaExport.SealNo'),
            colId: 'sealNo',
            field: 'sealNo',
            width: 100,
            editable: (params) => this.isEditing && this.isSent(params),
            headerClass: 'required-label',
            cellEditor: 'CargoAgGridCommonInputEditor',
            cellRenderer: (params) => {
              return this.formatConversion(params.value)
            },
            cellEditorParams: {
              isUppercase: true,
              isTrim: true,
              inputProps: {
                maxlength: this.isRongeTong ? 14 : 29
              }
            }
          }, {
            headerName: this.$t('SeaExport.ContainerSize'),
            colId: 'eqSize',
            field: 'eqSize',
            width: 100,
            editable: this.isEditing,
            headerClass: 'required-label',
            cellEditor: 'CargoAgGridAdvanceSelectEditor',
            cellEditorParams: {
              selectProps: {
                filterable: true,
                tagName: 'code',
                tagValue: 'code',
                filterTagNames: ['code'],
                staticOptions: this.getBoxList
              }
            },
            valueFormatter: params => {
              const boxs = this.getBoxList
              for (const data of boxs) {
                if (data.code === params.value) {
                  return data.code
                }
              }
              return ''
            },
            onCellValueChanged: p => this.onCellChange(p)
          }, {
            headerName: this.$t('queryJob.englishDescriptionOfGoods'),
            colId: 'cargoEnglishName',
            field: 'cargoEnglishName',
            width: 100,
            headerComponentParams: this.cargoEnglishNameCheck,
            editable: this.isEditing,
            headerClass: 'required-label',
            cellEditor: 'CargoAgGridCommonTextareaEditor',
            cellEditorParams: {
              autoUppercase: this.isUppercaseByConfig,
              inputProps: {
                maxlength: this.isRongeTong ? 2000 : 1024,
                showWordLimit: true,
                filterChars: false
              }
            }
            // onCellValueChanged: p => this.formatConversion2(p)
          }, {
            headerName: this.$t('SeaExport.Marks'),
            colId: 'mark',
            field: 'mark',
            width: 100,
            headerComponentParams: this.markCheck,
            editable: this.isEditing,
            headerClass: 'required-label',
            cellEditor: 'CargoAgGridCommonTextareaEditor',
            cellEditorParams: {
              autoUppercase: this.isUppercaseByConfig
            }
            // onCellValueChanged: p => this.formatConversion2(p)
          }, {
            headerName: 'HSCode',
            colId: 'hsCode',
            field: 'hsCode',
            width: 100,
            editable: this.isEditing,
            headerClass: '',
            cellEditor: 'CargoAgGridCommonTextareaEditor',
            onCellValueChanged: p => this.onCellChange(p),
            cellRenderer: (params) => {
              return this.formatConversion(params.value)
            }
          }, {
            headerName: this.$t('SeaExport.Package'),
            colId: 'packing',
            field: 'packing',
            width: 100,
            editable: this.isEditing,
            headerClass: 'required-label',
            cellEditor: 'CargoAgGridAdvanceSelectEditor',
            cellEditorParams: {
              selectProps: {
                filterable: true,
                tagName: 'name',
                tagValue: 'code',
                staticOptions: this.getPackages
              }
            },
            valueFormatter: params => {
              const packings = this.getPackages
              for (const data of packings) {
                if (data.code === params.value) {
                  return data.chineseName
                }
              }
              return ''
            }
          }, {
            headerName: this.$t('SeaExport.Quantity'),
            colId: 'quantity',
            field: 'quantity',
            width: 100,
            editable: this.isEditing,
            headerClass: 'required-label',
            cellEditor: 'CargoAgGridCommonInputEditor',
            cellEditorParams: {
              isNumber: true,
              inputProps: {
                min: 0
              }
            },
            onCellValueChanged: p => this.onCellChange(p)
          }, {
            headerName: this.$t('SeaExport.Weight'),
            colId: 'weight',
            field: 'weight',
            width: 100,
            valueFormatter: params => {
              return (Number(params.value) || 0).toFixed(3)
            },
            editable: this.isEditing,
            headerClass: 'required-label',
            cellEditor: 'CargoAgGridCommonInputEditor',
            cellEditorParams: {
              isNumber: true,
              inputProps: {
                min: 0.001,
                precision: 3,
                max: 1000000.999
              }
            },
            onCellValueChanged: p => this.onCellChange(p)
          }, {
            headerName: this.$t('SeaExport.Cubage'),
            colId: 'cubage',
            field: 'cubage',
            width: 100,
            valueFormatter: params => {
              return (Number(params.value) || 0).toFixed(3)
            },
            editable: this.isEditing,
            headerClass: 'required-label',
            cellEditor: 'CargoAgGridCommonInputEditor',
            cellEditorParams: {
              isNumber: true,
              inputProps: {
                min: 0.001,
                precision: 3,
                max: 2000.999
              }
            },
            onCellValueChanged: p => this.onCellChange(p)
          }, {
            headerName: 'UN Code',
            colId: 'danUNNo',
            field: 'danUNNo',
            width: 100,
            editable: this.isEditing,
            headerClass: () => {
              return this.isDangerousGoods ? 'required-label' : ''
            },
            cellEditor: 'CargoAgGridCommonInputEditor'
          }, {
            headerName: this.$t('SeaExport.DangerousClass'),
            colId: 'danClassNo',
            field: 'danClassNo',
            width: 100,
            editable: this.isEditing,
            headerClass: () => {
              return this.isDangerousGoods ? 'required-label' : ''
            },
            cellEditor: 'CargoAgGridCommonInputEditor',
            onCellValueChanged: p => this.onCellChange(p)
          }, {
            headerName: this.$t('SeaExport.PrimaryCustomsNo'),
            colId: 'masterSoNo',
            field: 'masterSoNo',
            suppressMenu: true,
            cellRendererFramework: 'agGridColumnEdit',
            custom: {
              isEdit: false,
              tag: 'el-checkbox',
              attrs: {
                isEditCBFunc: (params) => {
                  return this.innerIsEditing
                }
              }
            },
            width: 100
          }, {
            headerName: this.$t('SeaExport.ediStatus'),
            colId: 'ediStatus',
            field: 'ediStatus',
            width: 100,
            cellRenderer: params => {
              return ColumnUtils.ediStateFunction(params.data.ediStatus)
            }
          },
          {
            headerName: 'SOC',
            colId: 'soc',
            field: 'soc',
            suppressMenu: true,
            width: 50,
            cellRendererFramework: 'agGridColumnEdit',
            custom: {
              isEdit: false,
              tag: 'el-checkbox',
              attrs: {
                isEditCBFunc: (params) => {
                  return this.innerIsEditing
                }, trueLabel: 1, falseLabel: 0
              }
            }
          },
          {
            headerName: this.$t('SeaExport.emptyBox'),
            colId: 'emptyBox',
            field: 'emptyBox',
            suppressMenu: true,
            width: 50,
            cellRendererFramework: 'agGridColumnEdit',
            custom: {
              isEdit: false,
              tag: 'el-checkbox',
              attrs: {
                isEditCBFunc: (params) => {
                  return this.innerIsEditing
                }, trueLabel: 1, falseLabel: 0
              }
            }
          }, {
            headerName: this.$t('SeaExport.DangerousGoodsContact'),
            colId: 'dngrContactUser',
            field: 'dngrContactUser',
            width: 100,
            editable: this.isEditing,
            headerClass: () => {
              return this.isDangerousGoods ? 'required-label' : ''
            },
            cellEditor: 'CargoAgGridCommonInputEditor'
          }, {
            headerName: this.$t('SeaExport.DangerousGoodsContactPhoneNumber'),
            colId: 'dngrContactNumber',
            field: 'dngrContactNumber',
            width: 100,
            editable: this.isEditing,
            headerClass: () => {
              return this.isDangerousGoods ? 'required-label' : ''
            },
            cellEditor: 'CargoAgGridCommonInputEditor'
          }, {
            headerName: this.$t('SeaExport.ManifestDeliveryStatus'),
            colId: 'seaHouseState',
            field: 'seaHouseState',
            width: 100,
            cellRenderer: params => {
              return CommonState.getNameByCode(this.sendType, params.value)
            }
          }, {
            headerName: this.$t('SpecialGoods.dgContactEmail'),
            colId: 'dgContactEmail',
            field: 'dgContactEmail',
            width: 100,
            editable: this.isEditing,
            cellEditor: 'CargoAgGridCommonInputEditor'
          }, {
            headerName: this.$t('SpecialGoods.dgContactFax'),
            colId: 'dgContactFax',
            field: 'dgContactFax',
            width: 100,
            editable: this.isEditing,
            cellEditor: 'CargoAgGridCommonInputEditor'
          }, {
            headerName: this.$t('SpecialGoods.bookingNo'),
            colId: 'bookingNo',
            field: 'bookingNo',
            width: 100,
            editable: this.isEditing,
            cellEditor: 'CargoAgGridCommonInputEditor'
          }
        ]
        columnDefsGC = [
          {
            headerName: this.$t('SpecialGoods.Temp'),
            colId: 'temp',
            field: 'temp',
            width: 100,
            editable: this.isEditing,
            headerClass: 'required-label',
            cellEditor: 'CargoAgGridCommonInputEditor',
            cellEditorParams: {
              isNumber: true
            },
            valueFormatter: params => {
              if (params.value === -9999) {
                params.data.temp = null
                return ''
              } else {
                return params.value
              }
            }
          }, {
            headerName: this.$t('SpecialGoods.TemperatureUnit'),
            colId: 'tempUnit',
            field: 'tempUnit',
            width: 100,
            editable: this.isEditing,
            headerClass: 'required-label',
            cellEditor: 'CargoAgGridAdvanceSelectEditor',
            cellEditorParams: {
              selectProps: {
                filterable: true,
                tagName: 'name',
                tagValue: 'code',
                filterTagNames: ['code', 'name'],
                staticOptions: this.isRongeTong ? this.rongeTong.tempUnitList : this.wseCache.tempUnitList
              }
            },
            valueFormatter: params => {
              const tempUnitList = this.isRongeTong ? this.rongeTong.tempUnitList : this.wseCache.tempUnitList
              for (const data of tempUnitList) {
                if (data.code === params.value) {
                  return data.name
                }
              }
              return ''
            }
          }
        ]
        columnDefsGCTF = [
          {
            headerName: this.$t('SpecialGoods.VentilationWse'),
            colId: 'ventilation',
            field: 'ventilation',
            width: 100,
            editable: this.isEditing,
            headerClass: 'required-label',
            cellEditor: 'CargoAgGridCommonInputEditor',
            cellEditorParams: {
              isNumber: true
            }
          }
        ]
        columnDefsGCForSeaHouse = [
          {
            headerName: this.$t('SpecialGoods.Temp'),
            colId: 'temp',
            field: 'temp',
            width: 100,
            editable: this.isEditing,
            headerClass: 'required-label',
            cellEditor: 'CargoAgGridCommonInputEditor',
            cellEditorParams: {
              isNumber: true
            },
            valueFormatter: params => {
              if (params.value === -9999) {
                params.data.temp = null
                return ''
              } else {
                return params.value
              }
            }
          }, {
            headerName: this.$t('SpecialGoods.TemperatureUnit'),
            colId: 'tempUnit',
            field: 'tempUnit',
            width: 100,
            editable: this.isEditing,
            headerClass: 'required-label',
            cellEditor: 'CargoAgGridAdvanceSelectEditor',
            cellEditorParams: {
              selectProps: {
                filterable: true,
                tagName: 'name',
                tagValue: 'code',
                filterTagNames: ['code', 'name'],
                staticOptions: this.seaHouseCache.tempUnitList
              }
            },
            valueFormatter: params => {
              const boxs = this.seaHouseCache.tempUnitList
              for (const data of boxs) {
                if (data.code === params.value) {
                  return data.name
                }
              }
              return ''
            }
          }
        ]
        if (this.isRongeTong && this.isQingDao) {
          const carrierAgent = this.manifestInfo.thirdPartyCarrierAgent
          if (carrierAgent === '远大均胜') {
            const columnDefChineseName = [
              {
                headerName: this.$t('queryJob.chineseDescriptionOfGoods'),
                colId: 'cargoChineseName',
                field: 'cargoChineseName',
                width: 100,
                editable: this.isEditing,
                headerClass: 'required-label',
                cellEditor: 'CargoAgGridCommonTextareaEditor',
                cellEditorParams: {
                  autoUppercase: this.isUppercaseByConfig,
                  inputProps: {
                    maxlength: 2000,
                    showWordLimit: true,
                    filterChars: false
                  }
                }
              }
            ]
            columnDefs = [...columnDefs, ...columnDefChineseName]
          }
          if (carrierAgent === '远大均胜' || carrierAgent === '海丰船代' || carrierAgent === '日照中创') {
            const columnDefVGM = [
              {
                headerName: this.$t('SpecialGoods.VgmWeight'),
                colId: 'vgmWeight',
                field: 'vgmWeight',
                width: 100,
                valueFormatter: params => {
                  return (Number(params.value) || 0).toFixed(2)
                },
                editable: this.isEditing,
                headerClass: 'required-label',
                cellEditor: 'CargoAgGridCommonInputEditor',
                cellEditorParams: {
                  isNumber: true,
                  inputProps: {
                    min: 0.001,
                    precision: 3,
                    max: 2000.999
                  }
                },
                onCellValueChanged: p => this.onCellChange(p)
              }, {
                headerName: this.$t('Message.VgmWeightingMethod'),
                colId: 'vgmWeightingMethod',
                field: 'vgmWeightingMethod',
                width: 100,
                editable: this.isEditing,
                headerClass: 'required-label',
                cellEditor: 'CargoAgGridAdvanceSelectEditor',
                cellEditorParams: {
                  selectProps: {
                    filterable: true,
                    tagName: 'code',
                    tagValue: 'code',
                    filterTagNames: ['code'],
                    staticOptions: this.vgmWeightingMethodList
                  }
                },
                valueFormatter: params => {
                  const list = this.vgmWeightingMethodList
                  for (const data of list) {
                    if (data.code === params.value) {
                      return data.code
                    }
                  }
                  return ''
                },
                onCellValueChanged: p => this.onCellChange(p)
              }
            ]
            columnDefs = [...columnDefs, ...columnDefVGM]
          }
        }
        if (this.manifestInfo.dispatchingPlaceCode === 'CNRZH' && this.manifestInfo.thirdPartyCarrierAgent === 'ZC') {
          const columnDefVGM = [
            {
              headerName: this.$t('SpecialGoods.VgmWeight'),
              colId: 'vgmWeight',
              field: 'vgmWeight',
              width: 100,
              editable: this.isEditing,
              headerClass: 'required-label',
              cellEditor: 'CargoAgGridCommonInputEditor',
              cellEditorParams: {
                isNumber: true
              },
              onCellValueChanged: p => this.onCellChange(p)
            }
          ]
          columnDefs = [...columnDefs, ...columnDefVGM]
        }
      } else {
        columnDefs = [
          {
            headerName: '',
            field: '',
            width: 65,
            headerCheckboxSelection: true,
            checkboxSelection: true,
            sortable: false,
            suppressMenu: true,
            suppressSizeToFit: true,
            resizable: false
          },
          {
            headerName: this.$t('SeaExport.SoNo'),
            headerClass: () => {
              return this.isSeaHouseChannel ? 'required-label' : ''
            },
            colId: 'soNo',
            field: 'soNo',
            width: 100,
            hide: this.isAddSpelling,
            editable: this.isEditing,
            cellEditor: 'CargoAgGridCommonInputEditor',
            onCellValueChanged: p => this.onCellChange2(p)
          }, {
            headerName: this.$t('Payment.containerNo'),
            headerClass: () => {
              return this.isSeaHouseChannel ? 'required-label' : ''
            },
            colId: 'containerNo',
            field: 'containerNo',
            width: 100,
            cellStyle: params => {
              return this.containerNbrStyleFunction(params.data)
            },
            editable: this.isEditing,
            cellEditor: 'CargoAgGridCommonInputEditor',
            cellEditorParams: {
              isUppercase: true,
              isTrim: true
            }
          }, {
            headerName: this.$t('SeaExport.SealNo'),
            headerClass: () => {
              return this.isSeaHouseChannel ? 'required-label' : ''
            },
            colId: 'sealNo',
            field: 'sealNo',
            width: 100,
            editable: this.isEditing,
            cellEditor: 'CargoAgGridCommonInputEditor',
            cellEditorParams: {
              isUppercase: true,
              isTrim: true
            }
          }, {
            headerName: this.$t('SeaExport.ContainerSize'),
            headerClass: () => {
              return this.isSeaHouseChannel ? 'required-label' : ''
            },
            colId: 'eqSize',
            field: 'eqSize',
            width: 100,
            editable: this.isEditing,
            cellEditor: 'CargoAgGridCommonInputEditor'
          }, {
            headerName: this.$t('queryJob.englishDescriptionOfGoods'),
            headerClass: () => {
              return this.isSeaHouseChannel ? 'required-label' : ''
            },
            colId: 'cargoEnglishName',
            field: 'cargoEnglishName',
            width: 100,
            headerComponentParams: this.cargoEnglishNameCheck,
            editable: this.isEditing,
            cellEditor: 'CargoAgGridCommonTextareaEditor',
            cellEditorParams: {
              autoUppercase: this.isUppercaseByConfig,
              inputProps: {
                filterChars: false
              }
            }
          }, {
            headerName: this.$t('SeaExport.Marks'),
            headerClass: () => {
              return this.isSeaHouseChannel ? 'required-label' : ''
            },
            colId: 'mark',
            field: 'mark',
            width: 100,
            headerComponentParams: this.markCheck,
            editable: this.isEditing,
            cellEditor: 'CargoAgGridCommonTextareaEditor',
            cellEditorParams: {
              autoUppercase: this.isUppercaseByConfig
            }
          }, {
            headerName: 'HSCode',
            colId: 'hsCode',
            field: 'hsCode',
            width: 100,
            editable: this.isEditing,
            cellEditor: 'CargoAgGridCommonTextareaEditor'
          }, {
            headerName: this.$t('SeaExport.Package'),
            headerClass: () => {
              return this.isSeaHouseChannel ? 'required-label' : ''
            },
            colId: 'packing',
            field: 'packing',
            width: 100,
            editable: this.isEditing,
            cellEditor: 'CargoAgGridCommonInputEditor',
            onCellValueChanged: p => this.onCellChange(p)
          }, {
            headerName: this.$t('SeaExport.Quantity'),
            headerClass: () => {
              return this.isSeaHouseChannel ? 'required-label' : ''
            },
            colId: 'quantity',
            field: 'quantity',
            width: 100,
            editable: this.isEditing,
            cellEditor: 'CargoAgGridCommonInputEditor',
            cellEditorParams: {
              isNumber: true,
              inputProps: {
                min: 0
              }
            },
            onCellValueChanged: p => this.onCellChange(p)
          }, {
            headerName: this.$t('SeaExport.Weight'),
            headerClass: () => {
              return this.isSeaHouseChannel ? 'required-label' : ''
            },
            colId: 'weight',
            field: 'weight',
            width: 100,
            valueFormatter: params => {
              return (Number(params.value) || 0).toFixed(3)
            },
            editable: this.isEditing,
            cellEditor: 'CargoAgGridCommonInputEditor',
            cellEditorParams: {
              isNumber: true,
              inputProps: {
                min: 0,
                precision: 3
              }
            },
            onCellValueChanged: p => this.onCellChange(p)
          }, {
            headerName: this.$t('SeaExport.WeightUnit'),
            colId: 'weightUnit',
            field: 'weightUnit',
            width: 100,
            editable: this.isEditing,
            cellEditor: 'CargoAgGridSelectEditor',
            cellEditorParams: {
              selectProps: {
                filterable: true
              },
              options: WEIGHT_UNIT,
              tagName: 'code',
              tagValue: 'code'
            },
            onCellValueChanged: p => this.onCellChange(p)
          }, {
            headerName: this.$t('SeaExport.Cubage'),
            headerClass: () => {
              return this.isSeaHouseChannel ? 'required-label' : ''
            },
            colId: 'cubage',
            field: 'cubage',
            width: 100,
            valueFormatter: params => {
              return (Number(params.value) || 0).toFixed(3)
            },
            editable: this.isEditing,
            cellEditor: 'CargoAgGridCommonInputEditor',
            cellEditorParams: {
              isNumber: true,
              inputProps: {
                min: 0,
                precision: 3
              }
            },
            onCellValueChanged: p => this.onCellChange(p)
          }, {
            headerName: this.$t('SeaExport.CubageUnit'),
            colId: 'cubageUnit',
            field: 'cubageUnit',
            width: 100,
            editable: this.isEditing,
            cellEditor: 'CargoAgGridSelectEditor',
            cellEditorParams: {
              selectProps: {
                filterable: true
              },
              options: CUBAGE_UNIT,
              tagName: 'code',
              tagValue: 'code'
            },
            onCellValueChanged: p => this.onCellChange(p)
          }, {
            headerName: 'UN Code',
            colId: 'danUNNo',
            field: 'danUNNo',
            width: 100,
            editable: this.isEditing,
            cellEditor: 'CargoAgGridCommonInputEditor',
            onCellValueChanged: p => this.onCellChange(p)
          }, {
            headerName: this.$t('SeaExport.DangerousClass'),
            colId: 'danClassNo',
            field: 'danClassNo',
            width: 100,
            editable: this.isEditing,
            cellEditor: 'CargoAgGridCommonInputEditor'
          }, {
            headerName: this.$t('SeaExport.ediStatus'),
            colId: 'ediStatus',
            field: 'ediStatus',
            width: 100,
            cellRenderer: params => {
              return ColumnUtils.ediStateFunction(params.data.ediStatus)
            }
          }, {
            headerName: this.$t('FileHistory.operation'),
            colId: '_operate',
            field: '',
            width: 100,
            cellRendererFramework: 'iconDocumentCopy',
            custom: {
              isEdit: this.innerIsEditing,
              clicked: p => { this.copyAndAddItem(p) }
            }
          },
          {
            headerName: 'SOC',
            colId: 'soc',
            field: 'soc',
            suppressMenu: true,
            width: 50,
            cellRendererFramework: 'agGridColumnEdit',
            custom: {
              isEdit: false,
              tag: 'el-checkbox',
              attrs: {
                isEditCBFunc: (params) => {
                  return this.innerIsEditing
                }, trueLabel: 1, falseLabel: 0
              }
            }
          },
          {
            headerName: this.$t('SeaExport.emptyBox'),
            colId: 'emptyBox',
            field: 'emptyBox',
            suppressMenu: true,
            width: 50,
            cellRendererFramework: 'agGridColumnEdit',
            custom: {
              isEdit: false,
              tag: 'el-checkbox',
              attrs: {
                isEditCBFunc: (params) => {
                  return this.innerIsEditing
                }, trueLabel: 1, falseLabel: 0
              }
            }
          }, {
            headerName: this.$t('SeaExport.DangerousGoodsContact'),
            colId: 'dngrContactUser',
            field: 'dngrContactUser',
            width: 100,
            editable: this.isEditing,
            cellEditor: 'CargoAgGridCommonInputEditor'
          }, {
            headerName: this.$t('SeaExport.DangerousGoodsContactPhoneNumber'),
            colId: 'dngrContactNumber',
            field: 'dngrContactNumber',
            width: 100,
            editable: this.isEditing,
            cellEditor: 'CargoAgGridCommonInputEditor'
          }, {
            headerName: this.$t('SeaExport.Email2'),
            colId: 'email',
            field: 'email',
            width: 100,
            editable: this.isEditing,
            cellEditor: 'CargoAgGridCommonInputEditor'
          }, {
            headerName: this.$t('SeaExport.Fax'),
            colId: 'fax',
            field: 'fax',
            width: 100,
            editable: this.isEditing,
            cellEditor: 'CargoAgGridCommonInputEditor'
          }
        ]
      }
      if (this.dangerousInputMode) {
        columnDefs.push({
          headerName: this.$t('SeaExport.PackagingCategoryOfDangerousGoods'),
          colId: 'danPacking',
          field: 'danPacking',
          width: 100,
          hide: true,
          cellEditor: 'CargoAgGridSelectEditor',
          cellEditorParams: {
            selectProps: {
              clearable: true
            },
            options: PACKING_GOODS,
            tagName: this.isZh ? 'chineseName' : 'englishName',
            tagValue: 'code'
          }
        })
      } else {
        columnDefs.push({
          headerName: this.$t('SeaExport.PackagingCategoryOfDangerousGoods'),
          colId: 'danPacking',
          field: 'danPacking',
          width: 100,
          hide: true,
          editable: this.isEditing,
          cellEditor: 'CargoAgGridCommonInputEditor'
        })
      }

      if (this.isWseChannel && this.isQingDao && this.manifestInfo.thirdPartyCargoType === FROZEN_GOODS_WSE.code) {
        columnDefs = [...columnDefs, ...columnDefsGC, ...columnDefsGCTF]
      }
      if (this.isRongeTong && this.manifestInfo.thirdPartyCargoType === '冷冻品' || this.manifestInfo.thirdPartyCargoType === '冷藏危品') {
        columnDefs = [...columnDefs, ...columnDefsGC]
        if (this.isQingDao) {
          columnDefs = [...columnDefs, ...columnDefsGCTF]
        }
      }
      if (this.isSeaHouseChannel && this.isShangHai && this.manifestInfo.thirdPartyCargoType === FROZEN_GOODS_SEA_HOUSE.code) {
        columnDefs = [...columnDefs, ...columnDefsGCForSeaHouse]
      }
      columnDefs.push({
        headerName: this.$t('SeaExport.DangerousGoodsLabel'),
        colId: 'danLable',
        field: 'danLable',
        width: 100,
        hide: true,
        editable: this.isEditing,
        cellEditor: 'CargoAgGridCommonInputEditor'
      })
      columnDefs.push({
        headerName: this.$t('SpecialGoods.Point'),
        colId: 'danPoint',
        field: 'danPoint',
        width: 100,
        hide: true,
        editable: this.isEditing,
        cellEditor: 'CargoAgGridCommonInputEditor'
      })
      /* columnDefs.push({
        headerName: this.$t('SeaExport.SequenceNumber'),
        colId: 'serialNumber',
        field: 'serialNumber',
        hide: true,
        width: 100
      })*/
      return columnDefs
    },
    finalRowData() {
      return this.rowData.filter(p => !p.deleted)
    },
    isOocl() { // OOCL—东方海外 单独处理
      return this.manifestInfo.thirdPartyCarrier && this.manifestInfo.thirdPartyCarrier === 'OOCL'
    },
    getBoxList() {
      if (this.isRongeTong) {
        return this.rongeTong.boxList || []
      } else {
        return (this.isOocl && this.isSeaHouseChannel) ? this.seaHouseCache.ooclBoxList || [] : this.seaHouseCache.boxList || []
      }
    },
    getPackages() {
      if (this.isRongeTong) {
        return this.rongeTong.packages
      } else {
        return this.isOocl ? this.seaHouseCache.ooclPackages || [] : this.seaHouseCache.packages || []
      }
    }
  },
  watch: {
    manifestInfo(newVal) {
      this.init()
    },
    isSeaHouseChannel() {
      this.gridOptions.api.refreshHeader()
      return new Promise(resolve => {
        setTimeout(() => {
          this.gridOptions.api.refreshCells({ force: true })
        }, 100)
      })
    },
    isWseChannel() {
      this.gridOptions.api.refreshHeader()
      return new Promise(resolve => {
        setTimeout(() => {
          this.gridOptions.api.refreshCells({ force: true })
        }, 100)
      })
    },
    cargoType() {
      this.gridOptions.api.refreshHeader()
    },
    'manifestInfo.portOfLoading': {
      handler(val) {
        this.gridOptions.api.refreshHeader()
        this.initData()
      },
      deep: true
    },
    'manifestInfo.thirdPartyCargoType': {
      handler(val) {
        if (val === DANGEROUS_GOODS_SEA_HOUSE.code || val === DANGEROUS_GOODS_WSE.code || val === '危险品') {
          this.isDangerousGoods = true
        } else {
          this.isDangerousGoods = false
        }
        this.gridOptions.api.refreshHeader()
      },
      deep: true
    },
    'manifestInfo.dispatchingPlaceCode': {
      handler(val) {
        this.gridOptions.api.refreshHeader()
      },
      deep: true
    },
    'manifestInfo.thirdPartyCarrierAgent': {
      handler(val) {
        this.gridOptions.api.refreshHeader()
      },
      deep: true
    }
  },
  async created() {
    this.init()
    await this.initParams()
    await cache.load(cacheName.CONFIG)
    this.dangerousInputMode = parseInt(cache.config.get('DangerousInputMode')) === 1
  },
  methods: {
    isSent(params) {
      // 荣e通存在加拼的情况，所以需要看没条记录的单独状态看是否可以编辑
      if (this.isRongeTong) {
        const pallet = params.data
        const canUpdateStates = ['-1', '22', '23', '61']
        return !pallet.seaHouseState || canUpdateStates.indexOf(pallet.seaHouseState) > -1
      } else {
        return !PrePlanBookingUtil.isSent(this.manifestInfo)
      }
    },
    formatConversion(value) {
      return value ? String(value).trim().toUpperCase() : ''
    },
    async initParams() {
      await this.initData()
    },
    async initData() {
      const filterValue = this.isShangHai ? 'sh' : 'qd'
      if (this.isSeaHouseChannel || this.isWseChannel) {
        this.thirdPartyMappingUtil = await ThirdPartyMappingUtil.getInstance('seaHouse')
        this.seaHouseCache.boxList = this.thirdPartyMappingUtil.getListByDataTypeCarrierCode('box')
        this.seaHouseCache.packages = this.thirdPartyMappingUtil.getListByDataTypeCarrierCode('packing')
        this.seaHouseCache.ooclBoxList = this.thirdPartyMappingUtil.getListByDataTypeCarrierCode('box', 'OOCL')
        this.seaHouseCache.ooclPackages = this.thirdPartyMappingUtil.getListByDataTypeCarrierCode('packing', 'OOCL')
      } else if (this.isRongeTong) {
        this.thirdPartyMappingUtil = await ThirdPartyMappingUtil.getInstance('rongeTong')
        this.rongeTong.boxList = this.thirdPartyMappingUtil.getListByDataTypeCarrierCode('box').filter(t => t.filterValue === filterValue && t.cargoModuleName !== 'vgm')
        this.rongeTong.packages = this.thirdPartyMappingUtil.getListByDataTypeCarrierCode('packing').filter(t => t.filterValue === filterValue)
      }
      if (this.gridOptions.api) {
        this.gridOptions.api.refreshCells({ force: true })
      }
    },
    checkModels(tabName) {
      if (!this.rowData || this.rowData.length <= 0) return
      for (const item of this.rowData) {
        if (!item.deleted) {
          this.checkModel(item, tabName)
        }
      }
    },
    beforeUpload(file) {
      var fileType = file.name.substring(file.name.lastIndexOf('.') + 1)
      const extension = fileType === 'xls'
      const extension2 = fileType === 'xlsx'
      if (!extension && !extension2) {
        this.$message.warning(this.$t('SeaExport.FileOnlyXlsXlsx'))
      }
      return extension || extension2
    },
    uploadSuccess(response, file, fileList) {
      if (response && response.data) {
        this.saveImportData(response.data)
      } else {
        this.$message.warning(this.$t('SeaExport.ImportFailedContactAdministrator'))
      }
    },
    saveImportData(item) {
      const oldNum = SEUtils.getQuantity(this.job)
      const manifestInfo = this.manifestInfo
      const manifestGoods = manifestInfo.manifestGoods
      manifestGoods.push(...item.manifestGoods)
      if (SEUtils.needTip(this.job, 'SONO')) {
        const newNum = SEUtils.getQuantity(this.job)
        if (oldNum !== newNum) {
          this.$confirm(this.$t('CargoMsg.Cargo_SoNoChangeTips'), this.$t('CargoMsg.Cargo_Tips'), {
            confirmButtonText: this.$t('CargoMsg.Cargo_Confirm'),
            cancelButtonText: this.$t('CargoMsg.Cargo_Cancel'),
            type: 'warning'
          }).then(async() => {
            this.$emit('soNoChange', newNum)
          })
        }
      }
    },
    // 选中 勾选框或者其他列 都会触发[获取选中行]
    onGridCellFocused(event) {
      if (!event) return
      this.selectedRow = null
      if (this.gridApi && event.column) {
        this.gridApi.forEachNode(node => {
          if (node && node.rowIndex === event.rowIndex && node.data) {
            this.selectedRow = node.data
          }
        })
      }
    },
    onGridRowSelected(event) {
      if (!event || !event.data) return
      this.selectedRow = null
      if (event.node.isSelected()) {
        this.selectedRow = event.data
      }
      // 更新所有选中的行
      this.updateSelectedRows()
    },
    // 更新选中的行列表
    updateSelectedRows() {
      if (this.gridApi) {
        this.selectedRows = this.gridApi.getSelectedRows()
      }
    },
    // 行点击触发事件
    onRowClicked(event) {
      if (!event || !event.data) return
      this.selectedRow = event.data
    },
    onGridReady(params) {
      this.gridApi = params.api
    },
    init() {
      this.cargoEnglishNameCheck = null
      this.markCheck = null
      if (this.manifestInfo.uuid) {
        this.toQuery()
      } else {
        this.rowData = this.manifestInfo.manifestGoods || []
        this.calculation()
      }
    },
    async toQuery() {
      const manifestInfo = new ManifestInfo(this.manifestInfo)
      this.rowData = await manifestInfo.getManifestGoods()
      this.calculation()
      if (this.specialCharacterCheck) {
        const cargoEnglishName = []
        const mark = []
        for (const item of this.finalRowData) {
          let texts = StrUtils.getSpecialTexts(item.cargoEnglishName)
          if (texts && texts.length > 0) {
            cargoEnglishName.push(...texts)
          }
          texts = StrUtils.getSpecialTexts(item.mark)
          if (texts && texts.length > 0) {
            mark.push(...texts)
          }
        }
        if (cargoEnglishName.length > 0) {
          this.cargoEnglishNameCheck = getHeaderComponentParamsWithWarning(this.$t('CargoMsg.SpecialCharactersExcept') + '：' + Array.from(cargoEnglishName, p => `&#34;${p}&#34;`).join('，'))
        } else {
          this.cargoEnglishNameCheck = null
        }
        if (mark.length > 0) {
          this.markCheck = getHeaderComponentParamsWithWarning(this.$t('CargoMsg.SpecialCharactersExcept') + '：' + Array.from(mark, p => `&#34;${p}&#34;`).join('，'))
        } else {
          this.markCheck = null
        }
      }
      this.fillModel()
    },
    // 列编辑修改事件
    onCellChange(params) {
      const { node, colDef } = params
      const newValue = Number(params.newValue) || 0
      if (newValue < 0) {
        switch (colDef.field) {
          case 'quantity':
            node.setDataValue(colDef.colId || colDef.field, '0')
            break
          case 'weight':
          case 'cubage':
            node.setDataValue(colDef.colId || colDef.field, '0.000')
            break
        }
      }
      if (newValue > 0) {
        switch (colDef.field) {
          case 'weight':
            if ((this.isSeaHouseChannel || this.isWseChannel || this.isRongeTong) && (newValue < 0.001 || newValue > 1000000.999)) {
              node.setDataValue(colDef.colId || colDef.field, '0.000')
            }
            break
          case 'cubage':
            if ((this.isSeaHouseChannel || this.isWseChannel || this.isRongeTong) && (newValue < 0.001 || newValue > 2000.999)) {
              node.setDataValue(colDef.colId || colDef.field, '0.000')
            }
            break
          case 'vgmWeight':
            if ((this.isSeaHouseChannel || this.isWseChannel || this.isRongeTong) && (newValue < 0.001 || newValue > 9999999.999)) {
              node.setDataValue(colDef.colId || colDef.field, '0.000')
            }
            break
        }
      }
      this.calculation(colDef.field)
    },
    formatConversion2(value) {
      const { node, colDef } = value
      let formattedString = String(value.newValue) || ''
      const oldValue = String(value.oldValue) || ''
      if (oldValue === formattedString) {
        return
      }
      if (this.isWseChannel || this.isSeaHouseChannel || this.isRongeTong) {
        // 将输入字符串转换为大写
        formattedString = formattedString.toUpperCase()
        // 去除前后空格和回车符
        formattedString = formattedString.trim().replace(/\r?\n|\r/g, '/')
        // 将回车自动转换成/
        formattedString = formattedString.replace(/\n/g, '/')
      }
      node.setDataValue(colDef.colId || colDef.field, formattedString)
    },
    // 列编辑修改事件
    onCellChange2(params) {
      const { colDef } = params
      if (colDef.field && colDef.field === 'soNo') {
        this.soNoChangeHandler()
        this.soNoChangeFormat(params)
      }
    },
    soNoChangeHandler() {
      if (SEUtils.needTip2(this.job, 'SONO')) {
        this.$confirm(this.$t('CargoMsg.Cargo_SoNoChangeTips'), this.$t('CargoMsg.Cargo_Tips'), {
          confirmButtonText: this.$t('CargoMsg.Cargo_Confirm'),
          cancelButtonText: this.$t('CargoMsg.Cargo_Cancel'),
          type: 'warning'
        }).then(async() => {
          this.$emit('soNoChange', SEUtils.getQuantity(this.job))
        })
      }
    },
    soNoChangeFormat(value) {
      if (this.isRongeTong) {
        const { node, colDef } = value
        let formattedString = String(value.newValue) || ''
        const oldValue = String(value.oldValue) || ''
        if (oldValue === formattedString || !formattedString) {
          return
        }
        // 将输入字符串转换为大写,并且去除前后回车和空格
        formattedString = formattedString.toUpperCase().trim()
        node.setDataValue(colDef.colId || colDef.field, formattedString)
      }
    },
    showEditDialog(isNew, newRow) {
      if (isNew) {
        if (!newRow) {
          newRow = new ManifestGoodsInfo().fillDefaultValue().getData()
          newRow.weightUnit = 'KGS'
          newRow.cubageUnit = 'CBM'
        }
        newRow.manifestInfoUuid = this.manifestInfo.uuid
        newRow.serialNumber = PrePlanBookingUtil.getMaxSerialNumber(this.manifestInfo)
        this.rowData.push(newRow)
        // this.editDialog.form = newRow
        // this.editDialog.title = this.$t('common.btn.new')
      } else {
        // if (!this.isEditing) { // 查看
        //   this.editDialog.form = newRow
        //   this.editDialog.title = this.$t('common.btn.look')
        // } else {
        //   const row = this.selectedRow
        //   if (!row) { // 编辑
        //     this.$message.warning(this.$t('common.tips.hasOneAtleast'))
        //     return
        //   }
        //   if (!row.seq) {
        //     row.seq = this.autoIncrementNum.getNextNum()
        //   }
        //   this.editDialog.form = { ...row }
        //   this.editDialog.title = this.$t('common.btn.edit')
        // }
      }
      // this.editDialog.visible = true
    },
    showAdvanceTextDialog(title, value, successCallback) {
      this.advanceTextDialog.title = title
      this.advanceTextDialog.value = value
      this.advanceTextDialog.successCallback = successCallback
      this.advanceTextDialog.visible = true
    },
    finishAdvanceText() {
      const successCallback = this.advanceTextDialog.successCallback
      if (successCallback && typeof successCallback === 'function') {
        successCallback(this.advanceTextDialog.value)
      }
      this.advanceTextDialog.visible = false
    },
    fillModel() {
      if (!this.isOrNotDisplaySoNo && this.rowData && this.rowData.length > 0) {
        for (const item of this.rowData) {
          item.soNo = null // 加拼业务，货物信息关单号为null
        }
      }
    },
    checkModel(form, tabName) {
      if (!this.isAddSpelling && !form.soNo && this.isOrNotDisplaySoNo) {
        throw new TabError(`【${this.$t('SeaExport.CargoInfo')}】${this.$t('SeaExport.TheNoCannotBeBlank')}`, tabName)
      }
      if (!form.containerNo) {
        throw new TabError(`【${this.$t('SeaExport.CargoInfo')}】${this.$t('SeaExport.CaseNumberCannotBeEmpty')}`, tabName)
      }
      // 不做强制要求
      /* if (!ContainerNoHelper.checkContainerNo(form.containerNo)) {
        throw new TabError(`【${this.$t('SeaExport.CargoInfo')}】${this.$t('SeaExport.InvalidCaseNumber')}`, tabName)
      }*/
      if (!form.sealNo) {
        throw new TabError(`【${this.$t('SeaExport.CargoInfo')}】${this.$t('SeaExport.TheSealNumberCannotBeEmpty')}`, tabName)
      }
      if (!form.eqSize) {
        throw new TabError(`【${this.$t('SeaExport.CargoInfo')}】${this.$t('SeaExport.BoxTypeCannotBeEmpty')}`, tabName)
      }
      if (!form.cargoEnglishName) {
        throw new TabError(`【${this.$t('SeaExport.CargoInfo')}】${this.$t('SeaExport.EnglishNameCannotBeEmpty')}`, tabName)
      }
      if (!form.mark) {
        throw new TabError(`【${this.$t('SeaExport.CargoInfo')}】${this.$t('SeaExport.TheMarkCannotBeEmpty')}`, tabName)
      }
      if (!form.hsCode && !this.isSeaHouseChannel && !this.isWseChannel && !this.isRongeTong) {
        throw new TabError(`【${this.$t('SeaExport.CargoInfo')}】${this.$t('SeaExport.HscodeCannotBeEmpty')}`, tabName)
      }
      if (!form.packing) {
        throw new TabError(`【${this.$t('SeaExport.CargoInfo')}】${this.$t('SeaExport.ThePackageCannotBeEmpty')}`, tabName)
      }
      if (!form.quantity || Number(form.quantity) <= 0) {
        throw new TabError(`【${this.$t('SeaExport.CargoInfo')}】${this.$t('SeaExport.ThePiecesCannotBeEmpty')}`, tabName)
      }
      if (!form.weight || Number(form.weight) <= 0) {
        throw new TabError(`【${this.$t('SeaExport.CargoInfo')}】${this.$t('SeaExport.GrossWeightCannotBeEmpty')}`, tabName)
      }
      if (!form.cubage || Number(form.cubage) <= 0) {
        throw new TabError(`【${this.$t('SeaExport.CargoInfo')}】${this.$t('SeaExport.VolumeCannotBeEmpty')}`, tabName)
      }
      // 如果是海管家通道，且填了UN CODE,危险品等级，则需限制填写是否正确
      if (this.isSeaHouseChannel) {
        if (form.danUNNo) {
          if (!isNumber(form.danUNNo) || form.danUNNo.length !== 4) {
            throw new TabError(`【${this.$t('SeaExport.CargoInfo')}】${this.$t('SeaExport.DanUNNoCannotBeEmpty')}`, tabName)
          }
        }
        if (form.danClassNo) {
          if (!isNumber(form.danClassNo) || !(Number(form.danClassNo) >= 1 && Number(form.danClassNo) <= 9.9)) {
            throw new TabError(`【${this.$t('SeaExport.CargoInfo')}】${this.$t('SeaExport.DanClassNoCannotBeEmpty')}`, tabName)
          }
        }
      }
      // 如果货物类型是危险品，则需要校验【危险品联系人】【危险品联系人电话】字段必填。
      if ((this.showCombinedManifest && this.manifestInfo.cargoType === 'DG') || (this.manifestInfo.thirdPartyCargoType === DANGEROUS_GOODS_SEA_HOUSE.code && this.isSeaHouseChannel)) {
        if (StrUtils.isEmpty(form.dngrContactUser)) {
          throw new TabError(`【${this.$t('SeaExport.CargoInfo')}】${this.$t('SeaExport.DangerousGoodsContactCannotBeEmpty')}`, tabName)
        }
        if (StrUtils.isEmpty(form.dngrContactNumber)) {
          throw new TabError(`【${this.$t('SeaExport.CargoInfo')}】${this.$t('SeaExport.DangerousGoodsContactPhoneNumberCannotBeEmpty')}`, tabName)
        }
      }
    },
    save() {
      // const form = this.editDialog.form
      // const tabName = 'tabPrePlanBooking'
      // this.checkModel(form, tabName)
      // if (!form.seq) {
      //   this.rowData.push(form)
      // } else {
      //   const row = this.rowData.find(p => p.seq === form.seq)
      //   if (row) {
      //     Object.assign(row, form)
      //     this.gridApi.refreshCells({ force: true })
      //   }
      // }
      // // this.$message.success(this.$t('common.tips.saveSuccess'))
      // this.editDialog.visible = false
    },
    remove() {
      const rows = this.gridApi.getSelectedRows()
      if (rows && rows.length === 0) {
        this.$message.warning(this.$t('common.tips.hasOneAtleast'))
        return
      }
      // this.$confirm(this.$t('common.tips.confirmDelete'), this.$t('common.tips.prompt'), {
      //   confirmButtonText: this.$t('common.btn.ok'),
      //   cancelButtonText: this.$t('common.btn.cancel'),
      //   type: 'warning'
      // }).then(() => {
      let d = false
      if (this.rowData) {
        for (let i = this.rowData.length - 1; i >= 0; --i) {
          const row = this.rowData[i]
          if (rows.includes(row)) {
            if (row.uuid) {
              row.deleted = true
            } else {
              this.rowData.splice(i, 1)
            }
            // soNo有值 删除时触发费用计算
            if (row.soNo) {
              d = true
            }
          }
        }
      }
      const tempRowData = this.rowData
      this.rowData = []
      this.$nextTick(() => {
        this.rowData = tempRowData
        this.calculation()
      })
      if (d) {
        this.soNoChangeHandler()
      }
      // this.$message.success(this.$t('common.tips.deleteSuccess'))
    //   }).catch(() => { })
    },
    // 从装箱信息导入
    async importFromContainer() {
      const job = new SeaExportJob(this.job)
      const containerUsages = await this.getContainerUsages(job)
      let poItems = []
      if (this.isSeaHouseChannel) {
        poItems = await job.getPoItems()
      }
      if (containerUsages && containerUsages.length > 0) {
        let newManifestGoodsInfos = []
        let ediPkList = []
        let ediEqList = []
        if (this.isWseChannel || this.isRongeTong) {
          await getMappingList({ sendingPlatform: WSE_MANIFEST.code, officeId: this.$store.getters.currentOfficeId }).then((res) => {
            if (res && res.data) {
              ediPkList = res.data.filter(e => e.type === 'EDI_PK') || []
              ediEqList = res.data.filter(e => e.type === 'EDI_EQ') || []
            }
          })
        }
        if ((this.isSeaHouseChannel || this.isWseChannel || this.isRongeTong) && !job.masterFlag) {
          newManifestGoodsInfos = await PrePlanBookingUtil.syncPoItems(containerUsages, this.rowData, job, this.manifestInfo, poItems, ediPkList, ediEqList)
        } else {
          newManifestGoodsInfos = await PrePlanBookingUtil.syncContainer(containerUsages, this.rowData, job, this.manifestInfo, this.isSeaHouseChannel, ediPkList, ediEqList)
        }
        this.rowData = newManifestGoodsInfos
        this.calculation()
        // 主票同步时，拿到下面下票信息的危险品和联合国编码，代入到列表中
        if (job.lclSlaves.length > 0) {
          console.log('job.lclSlaves', job.lclSlaves)
          for (const slaves of job.lclSlaves) {
            const Jobslaves = new SeaExportJob(slaves)
            const result = await Jobslaves.getSpecialGoods()
            if (result.length > 0) {
              this.rowData.forEach((item) => {
                if (item.jobUuid === result[0].jobUuid) {
                  item.danUNNo = result[0].danUNNo
                  item.danClassNo = result[0].danClassNo
                }
              })
            }
          }
        } else {
          const singleData = await job.getSpecialGoods()
          this.rowData.forEach((item) => {
            if (singleData[0] && (item.jobUuid === singleData[0].jobUuid)) {
              item.danUNNo = singleData[0].danUNNo
              item.danClassNo = singleData[0].danClassNo
            }
          })
        }
        this.gridApi.refreshCells({ force: true })
      } else {
        this.$message.info(this.$t('SeaExport.TherePleaseEnterItTab'))
      }
    },
    // 同步更新装箱信息
    async synchronizePackingInfo() {
      if (!this.manifestInfo.uuid) {
        this.$message.warning(this.$t('SeaExport.ManifestDataIsEmpty'))
        return
      }
      if (!this.manifestInfo.manifestGoods || this.manifestInfo.manifestGoods.length === 0) {
        this.$message.warning(this.$t('SeaExport.CargoInformationIsEmpty'))
        return
      }
      if (this.vgmRequiredInput && (!this.manifestInfo.manifestVGMs || this.manifestInfo.manifestVGMs.length === 0)) {
        this.$message.warning(this.$t('SeaExport.VGMIsEmpty'))
        return
      }
      if (this.manifestInfo.cfmState !== ManifestCfmState.CFM_STATE_DONE.code) {
        this.$message.warning(this.$t('SeaExport.ManifestNotConfirmed'))
        return
      }
      // 判断箱型箱种
      if (!this.job.seaEQ) {
        this.$message.warning(this.$t('SeaExport.NoDataSynced'))
        return
      }
      let eqFlag = false
      for (const item of this.manifestInfo.manifestGoods) {
        for (const eq of this.job.seaEQ) {
          if (item.eqSize === eq.eqSize + eq.eqType || (['40HQ', '40HC'].indexOf(item.eqSize) > -1 && ['40HQ', '40HC'].indexOf(eq.eqSize + eq.eqType) > -1)) {
            eqFlag = true
            break
          }
        }
        if (eqFlag) {
          break
        }
      }
      if (!eqFlag) {
        this.$message.warning(this.$t('SeaExport.NoDataSynced'))
        return
      }
      const flag = await this.$confirm(this.$t('SeaExport.AreYouSureSynchronizePackingInfo'), this.$t('Message.Prompt'), {
        confirmButtonText: this.$t('common.btn.ok'),
        cancelButtonText: this.$t('common.btn.cancel'),
        dangerouslyUseHTMLString: true,
        closeOnClickModal: false,
        type: 'warning'
      }).then(() => true).catch(() => false)
      if (!flag) {
        return
      }
      const self = this
      self.loading = getLoading()
      synchronousManifest({
        manifestInfoUuid: this.manifestInfo.uuid,
        branchId: this.$store.getters.currentOfficeId
      }).then(res => {
        this.$emit('reload')
        this.$message.success(this.$t('Message.SynchronizationSucceeded'))
      }).catch().finally(() => {
        self.loading.close()
      })
    },
    // 确认
    async cfmBtnClickHandlers() {
      if (!this.manifestInfo.uuid) {
        this.$message.warning(this.$t('SeaExport.ManifestDataIsEmpty'))
        return
      }
      if (!this.manifestInfo.manifestGoods || this.manifestInfo.manifestGoods.length === 0) {
        this.$message.warning(this.$t('SeaExport.CargoInformationIsEmpty'))
        return
      }
      if (this.vgmRequiredInput && (!this.manifestInfo.manifestVGMs || this.manifestInfo.manifestVGMs.length === 0)) {
        this.$message.warning(this.$t('SeaExport.VGMIsEmpty'))
        return
      }
      const self = this
      self.loading = getLoading()
      confirmManifest({
        manifestInfoUuid: this.manifestInfo.uuid,
        branchId: this.$store.getters.currentOfficeId
      }).then(res => {
        this.$emit('reload')
        this.$message.success(this.$t('SeaExport.ManifestConfirmed'))
      }).catch().finally(() => {
        self.loading.close()
      })
    },
    async getContainerUsages(job) {
      // 如果是主票
      const masterContainerUsages = []
      if (job.masterFlag) {
        const containers = await job.getContainers()
        if (containers && containers.length > 0) {
          for (const container of containers) {
            if (container.containerUsage && container.containerUsage.length > 0) {
              for (const usage of container.containerUsage) {
                const tempUsage = deepClone(usage)
                tempUsage.container = container
                masterContainerUsages.push(tempUsage)
              }
            }
          }
        }
        return masterContainerUsages
      }
      // 非主票
      return await job.getContainerUsages()
    },
    // 从主票导入
    importFromLcLContainer() {
      if (!this.job.lclMasterUuid) {
        this.$message.info(this.$t('SeaExport.NoMasterTicketInformationYet'))
        return
      }
      // ManifestInfo.synchronizationGoodsInfoByX(manifestInfo.job.key, importSuccessHandler, faultHandler)
    },
    // 复制/查看
    copyAndAddItem(params) {
      const source = params.data
      if (!this.isEditing) { // 查看
        this.showEditDialog(false, source)
        return
      }
      const newRow = new ManifestGoodsInfo().fillDefaultValue().getData()
      newRow.soNo = source.soNo
      newRow.containerNo = source.containerNo
      newRow.sealNo = source.sealNo
      newRow.eqSize = source.eqSize
      newRow.cargoEnglishName = source.cargoEnglishName
      newRow.mark = source.mark
      newRow.hsCode = source.hsCode
      newRow.packing = source.packing
      newRow.quantity = source.quantity
      newRow.weight = source.weight
      newRow.cubage = source.cubage
      newRow.weightUnit = source.weightUnit
      newRow.cubageUnit = source.cubageUnit
      newRow.danUNNo = source.danUNNo
      newRow.danClassNo = source.danClassNo
      this.showEditDialog(true, newRow)
    },
    containerNbrStyleFunction(data) {
      if (!ContainerNoHelper.checkContainerNo(data.containerNo)) {
        return { color: '#FF0000' }
      }
      return { color: '' }
    },
    changeMark(val) {
      this.editDialog.form.mark = StrUtils.toHalfword(val)
    },
    changeCargoEnglishName(val) {
      this.editDialog.form.cargoEnglishName = StrUtils.toHalfword(val)
    },
    importReload(manifestGoods) {
      this.rowData = manifestGoods
      this.gridApi.refreshCells({ force: true })
    },
    /*,
    containerNbrChange() {
      this.containerNoClass = this.containerNbrStyleFunction({ containerNo: this.editDialog.form.containerNo })
    }*/
    // 修改件毛体
    calculation(colId) {
      let quantity = 0
      let cubage = 0
      let weight = 0
      switch (colId) {
        case 'quantity':
          this.finalRowData.forEach(eve => {
            if (!eve.quantity) {
              eve.quantity = 0
            }
            quantity += parseInt(eve.quantity)
          })
          this.quantity = quantity
          break
        case 'weight':
          this.finalRowData.forEach(eve => {
            if (!eve.weight) {
              eve.weight = 0.000
            }
            weight += parseFloat(eve.weight)
          })
          this.weight = Number(weight).toFixed(3)
          break
        case 'cubage':
          this.finalRowData.forEach(eve => {
            if (!eve.cubage) {
              eve.cubage = 0.000
            }
            cubage += parseFloat(eve.cubage)
          })
          this.cubage = Number(cubage).toFixed(3)
          break
        default:
          this.finalRowData.forEach(eve => {
            if (!eve.quantity) {
              eve.quantity = 0
            }
            if (!eve.cubage) {
              eve.cubage = 0.000
            }
            if (!eve.weight) {
              eve.weight = 0.000
            }
            weight += parseFloat(eve.weight)
            cubage += parseFloat(eve.cubage)
            quantity += parseInt(eve.quantity)
          })
          this.quantity = quantity
          this.weight = Number(weight).toFixed(3)
          this.cubage = Number(cubage).toFixed(3)
      }
    },
    // 更改船司
    changeThirdPartyCarrier() {
      if (this.isWseChannel || this.isRongeTong) {
        return
      }
      if (!this.finalRowData || !this.manifestInfo.thirdPartyCarrier) {
        return
      }
      for (const curRow of this.finalRowData) {
        if (this.isOocl) {
          const eqSize = (curRow.eqSize && this.seaHouseCache.ooclBoxList) ? this.seaHouseCache.ooclBoxList.filter(p => p.code === curRow.eqSize)[0] : null
          if (!eqSize) curRow.eqSize = ''
          const packing = (curRow.packing && this.seaHouseCache.ooclPackages) ? this.seaHouseCache.ooclPackages.filter(p => p.code === curRow.packing)[0] : null
          if (!packing) curRow.packing = ''
        } else {
          const eqSize = (curRow.eqSize && this.seaHouseCache.boxList) ? this.seaHouseCache.boxList.filter(p => p.code === curRow.eqSize)[0] : null
          if (!eqSize) curRow.eqSize = ''
          const packing = (curRow.packing && this.seaHouseCache.packages) ? this.seaHouseCache.packages.filter(p => p.code === curRow.packing)[0] : null
          if (!packing) curRow.packing = ''
        }
      }
      this.gridApi.setRowData(this.finalRowData)
      this.gridApi.refreshCells({ force: true })
    },
    copy() {
      const rows = this.gridApi.getSelectedRows()
      if (!rows || rows.length === 0) {
        this.$message.warning(this.$t('SeaExport.ChooseSoNoInfoToCopy'))
        return
      }
      // 添加勾选数据
      for (const row of rows) {
        const newRow = new ManifestGoodsInfo().fillDefaultValue().getData()
        commonUtil.objCopy(row, newRow)
        // 初始化 状态数据
        newRow.uuid = ''
        newRow.ediStatus = 0
        newRow.manifestId = null
        newRow.seaHouseState = '-1'
        newRow.changeState = 0
        this.rowData.push(newRow)
      }
    },
    loadChooseData() {
      return this.gridApi.getSelectedRows()
    },
    async getSoNoList(row) {
      const job = new SeaExportJob(row)
      this.soNoList = []
      if (!job) {
        return
      }
      const soNos = job.soNo ? job.soNo.split('\n') : []
      for (const item of soNos) {
        if (item && this.soNoList.findIndex(p => p.code === item) === -1) {
          this.soNoList.push({ code: item, name: item })
        }
      }
      const poItems = await job.getPoItems()
      // 将 poItems 里面的 soNo 去重后放入 soNoList
      if (poItems && poItems.length > 0) {
        for (const item of poItems) {
          if (item.soNo && this.soNoList.findIndex(p => p.code === item.soNo) === -1) {
            this.soNoList.push({ code: item.soNo, name: item.soNo })
          }
        }
      }
    },
    // 转大写并去除空格
    toUpperCaseTrim(val) {
      return val.toUpperCase().trim()
    }
  }
}
</script>

<style lang="scss" scoped>
  .booking-manifest-goods-info{
    /deep/ .required-label .ag-header-cell-text{
      color: #1F75D5 !important;
    }
  }
</style>
